"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[821],{

/***/ 4559:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RecaptchaModal; }
/* harmony export */ });
/* unused harmony export RecaptchaCheckbox */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);



function RecaptchaCheckboxInner(param) {
    var _siteKey = param.siteKey, siteKey = _siteKey === void 0 ? "6LcMXrYrAAAAAO_ST6vZ-pm1SnS4P0nWJX2qXsiA" : _siteKey, onVerify = param.onVerify, onExpired = param.onExpired, onError = param.onError, _theme = param.theme, theme = _theme === void 0 ? "light" : _theme, _size = param.size, size = _size === void 0 ? "normal" : _size, _widgetIdRef = param.widgetIdRef, widgetIdRef = _widgetIdRef === void 0 ? null : _widgetIdRef;
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var internalWidgetId = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var mounted = true;
        if (!siteKey) {
            onError && onError(new Error("reCAPTCHA site key not configured"));
            return;
        }
        var ensureScript = function() {
            return new Promise(function(resolve, reject) {
                if (window.grecaptcha && window.grecaptcha.render) return resolve();
                var existing = document.querySelector('script[src*="recaptcha/api.js"]');
                if (existing) {
                    existing.addEventListener("load", function() {
                        return resolve();
                    });
                    existing.addEventListener("error", function() {
                        return reject(new Error("recaptcha script failed to load"));
                    });
                    return;
                }
                var s = document.createElement("script");
                s.src = "https://www.google.com/recaptcha/api.js?render=explicit";
                s.async = true;
                s.defer = true;
                s.onload = function() {
                    return resolve();
                };
                s.onerror = function() {
                    return reject(new Error("recaptcha script failed to load"));
                };
                document.head.appendChild(s);
            });
        };
        ensureScript().then(function() {
            if (!mounted) return;
            if (!window.grecaptcha || !window.grecaptcha.render) {
                onError && onError(new Error("grecaptcha not available"));
                return;
            }
            try {
                var id = window.grecaptcha.render(containerRef.current, {
                    sitekey: siteKey,
                    theme: theme,
                    size: size,
                    callback: function(token) {
                        onVerify && onVerify(token);
                    },
                    "error-callback": function() {
                        onError && onError(new Error("reCAPTCHA checkbox verification failed"));
                    },
                    "expired-callback": function() {
                        onExpired && onExpired();
                    }
                });
                internalWidgetId.current = id;
                if (widgetIdRef && typeof widgetIdRef === "object") widgetIdRef.current = id;
            } catch (err) {
                onError && onError(err);
            }
        }).catch(function(err) {
            return onError && onError(err);
        });
        return function() {
            mounted = false;
            try {
                if (internalWidgetId.current != null && window.grecaptcha && window.grecaptcha.reset) {
                    window.grecaptcha.reset(internalWidgetId.current);
                }
            } catch (e) {}
        };
    }, [
        siteKey,
        onVerify,
        onExpired,
        onError,
        theme,
        size,
        widgetIdRef
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: containerRef
    });
}
function RecaptchaCheckbox(props) {
    return /*#__PURE__*/ _jsx(RecaptchaCheckboxInner, _object_spread({}, props));
}
function RecaptchaModal(param) {
    var _message = param.message, message = _message === void 0 ? "Please complete the verification to continue" : _message, onVerify = param.onVerify, onError = param.onError, onClose = param.onClose, siteKey = param.siteKey, theme = param.theme, size = param.size;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            position: "fixed",
            inset: 0,
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    background: "rgba(0,0,0,0.5)",
                    position: "absolute",
                    inset: 0
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                style: {
                    zIndex: 10000,
                    background: "#fff",
                    padding: 20,
                    borderRadius: 8,
                    minWidth: 320,
                    maxWidth: "90%"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        style: {
                            marginBottom: 10
                        },
                        children: message
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RecaptchaCheckboxInner, {
                        siteKey: siteKey,
                        theme: theme,
                        size: size,
                        onVerify: function(token) {
                            return onVerify && onVerify(token);
                        },
                        onError: function() {
                            return onError && onError();
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: {
                            marginTop: 8,
                            textAlign: "right"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            type: "button",
                            className: "px-4 py-2 text-sm",
                            onClick: function() {
                                return onClose && onClose();
                            },
                            children: "Cancel"
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 3976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SEO_SEO; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./lib/seo-config.js
var SITE_CONFIG = {
    name: "Evry Health",
    url: "https://www.evryhealth.com",
    defaultOgImage: "https://www.evryhealth.com/og-image.png",
    twitterCard: "summary_large_image"
};
var PAGE_SEO = {
    "": {
        title: "Evry Health | Modern Health Insurance for Texas Employers & Members",
        description: "Evry Health offers transparent, member-first health insurance for Texas employers (51+ employees) and their members — with $0 telehealth, no copays, no deductibles, and a personalized care team.",
        ogDescription: "Transparent, member-first health insurance for Texas employers and members. No copays. No deductibles. $0 telehealth.",
        twitterTitle: "Evry Health",
        twitterDescription: "Modern health insurance for Texas employers and members."
    },
    "admission-notification": {
        title: "Inpatient Admission Notification | Evry Health",
        description: "How to submit inpatient admission notifications to Evry Health to ensure timely, accurate claims processing.",
        ogDescription: "How to submit inpatient admission notifications to Evry Health.",
        twitterTitle: "Admission Notification | Evry Health",
        twitterDescription: "Submit inpatient admission notifications to Evry Health."
    },
    careers: {
        title: "Careers at Evry Health | Join Our Team",
        description: "We're making health insurance work again. Explore open roles at Evry Health in Dallas, Texas.",
        twitterTitle: "Careers at Evry Health",
        twitterDescription: "Explore open roles at Evry Health in Dallas, Texas."
    },
    "community-resources": {
        title: "Texas Community Resources for Members | Evry Health",
        description: "A curated list of local community, health, food, and legal resources across Texas for Evry Health members.",
        twitterTitle: "Texas Community Resources | Evry Health",
        twitterDescription: "Community, health, food, and legal resources for Evry Health members in Texas."
    },
    "contact-us": {
        title: "Contact Evry Health | Get a Quote",
        description: "Get in touch with Evry Health for plan quotes, member support, or general questions. Call 1-855-579-3879.",
        ogDescription: "Get in touch with Evry Health for plan quotes, member support, or general questions.",
        twitterTitle: "Contact Evry Health",
        twitterDescription: "Get a quote or ask us anything. Call 1-855-579-3879."
    },
    faqs: {
        title: "Frequently Asked Questions | Evry Health",
        description: "Answers to common questions about Evry Health plans, coverage, virtual care, and member benefits.",
        twitterDescription: "Answers to common questions about Evry Health plans and coverage."
    },
    forms: {
        title: "Forms & Notices | Evry Health",
        description: "Download member and provider forms, notices, and resources from Evry Health.",
        twitterDescription: "Download forms and notices from Evry Health."
    },
    fwa: {
        title: "Report Fraud, Waste & Abuse | Evry Health",
        description: "How Evry Health members and providers can report suspected fraud, waste, or abuse.",
        twitterDescription: "Report suspected fraud, waste, or abuse to Evry Health."
    },
    "how-we-compare": {
        title: "How Evry Health Compares | Plan Comparison",
        description: "Compare Evry Health plans against traditional carriers — no deductibles, no copays, $0 virtual care, and transparent premiums.",
        ogDescription: "Compare Evry Health plans against traditional carriers — no deductibles, no copays, $0 virtual care.",
        twitterTitle: "How Evry Health Compares",
        twitterDescription: "Compare Evry Health plans against traditional carriers."
    },
    "how-we-do-it": {
        title: "How Evry Health Works | Built for Modern Workforces",
        description: "Evry Health is built for the modern business and the mobile workforce. See how our health insurance plans work.",
        twitterTitle: "How Evry Health Works",
        twitterDescription: "Built for the modern business and the mobile workforce."
    },
    "join-the-evry-network": {
        title: "Join the Evry Health Provider Network",
        description: "Apply to join the Evry Health provider network. Faster payments. Transparent terms.",
        twitterTitle: "Join the Evry Health Network",
        twitterDescription: "Apply to join the Evry Health provider network."
    },
    login: {
        title: "Sign In | Evry Health",
        description: "Sign in to the Evry Health member portal.",
        noindex: true
    },
    "meet-your-new-team": {
        title: "Meet Your Evry Health Care Team",
        description: "Every Evry Health member gets a dedicated team of nurses, nutritionists, and doctors — included at no extra cost.",
        ogDescription: "Every member gets a dedicated team of nurses, nutritionists, and doctors — at no extra cost.",
        twitterDescription: "A dedicated team of nurses, nutritionists, and doctors — included at no extra cost."
    },
    members: {
        title: "Member Registration | Evry Health",
        description: "Register for your Evry Health member portal account.",
        noindex: true
    },
    mobileapp: {
        title: "Evry Health Mobile App | Manage Your Plan On the Go",
        description: "Download the Evry Health mobile app to view your ID card, find providers, message your care team, and more.",
        ogDescription: "Download the Evry Health mobile app to view your ID card, find providers, and message your care team.",
        twitterTitle: "Evry Health Mobile App",
        twitterDescription: "Manage your health plan on the go with the Evry Health app."
    },
    news: {
        title: "News & Press | Evry Health",
        description: "The latest news, press releases, and announcements from Evry Health.",
        twitterDescription: "The latest news and announcements from Evry Health."
    },
    "non-discrimination-policy": {
        title: "Non-Discrimination Policy | Evry Health",
        description: "Evry Health's commitment to non-discrimination and language assistance for members.",
        twitterDescription: "Non-discrimination and language assistance for all members."
    },
    "our-story": {
        title: "Our Story | Evry Health",
        description: "Evry Health is on a mission to build the health insurance company we've always wanted for ourselves.",
        ogDescription: "We're on a mission to build the health insurance company we've always wanted for ourselves.",
        twitterDescription: "Building the health insurance company we've always wanted."
    },
    partners: {
        title: "Partners | Evry Health",
        description: "The partners and providers Evry Health works with to deliver modern health insurance.",
        twitterDescription: "Partners and providers delivering modern health insurance."
    },
    "prior-auth-list-updates": {
        title: "Prior Authorization List Updates | Evry Health",
        description: "Recent updates to the Evry Health prior authorization list for providers.",
        twitterDescription: "Recent updates to the prior authorization list for providers."
    },
    "prior-auth-tool": {
        title: "Prior Authorization Tool | Evry Health for Providers",
        description: "Look up whether a procedure requires prior authorization with Evry Health.",
        twitterTitle: "Prior Authorization Tool | Evry Health",
        twitterDescription: "Check if prior authorization is required for a procedure."
    },
    "prior-authorization": {
        title: "Prior Authorization | Evry Health for Providers",
        description: "Information for providers on which procedures require prior authorization with Evry Health.",
        ogDescription: "Provider resources for prior authorization with Evry Health.",
        twitterTitle: "Prior Authorization | Evry Health",
        twitterDescription: "Provider resources for prior authorization with Evry Health."
    },
    "privacy-policy": {
        title: "Privacy Policy | Evry Health",
        description: "How Evry Health collects, uses, and protects your personal and health information.",
        twitterDescription: "How Evry Health protects your personal and health information."
    },
    providerdirectory: {
        title: "Provider Directory | Evry Health",
        description: "Find in-network providers with the Evry Health provider directory.",
        noindex: true
    },
    "request-to-join": {
        title: "Request to Join | Evry Health Network",
        description: "Submit a request to join the Evry Health provider network. Simple application process.",
        ogDescription: "Submit a request to join the Evry Health provider network.",
        twitterTitle: "Request to Join | Evry Health",
        twitterDescription: "Join the Evry Health provider network."
    },
    "retrospective-reviews": {
        title: "Retrospective Reviews | Evry Health for Providers",
        description: "Learn how Evry Health determines coverage after treatment has been provided.",
        twitterTitle: "Retrospective Reviews | Evry Health",
        twitterDescription: "How Evry Health determines coverage after treatment."
    },
    rewards: {
        title: "Member Rewards | Evry Health",
        description: "Earn rewards for staying healthy as an Evry Health member.",
        twitterDescription: "Earn rewards for staying healthy with Evry Health."
    },
    terms: {
        title: "Terms of Use | Evry Health",
        description: "Terms of use for the Evry Health website and digital services.",
        twitterDescription: "Terms of use for Evry Health website and services."
    },
    "virtual-care": {
        title: "$0 Virtual Care & Telehealth | Evry Health",
        description: "Talk to a board-certified physician 24/7 for $0. On-demand virtual care included with every Evry Health plan.",
        twitterDescription: "Talk to a board-certified physician 24/7 for $0."
    },
    "why-choose-evry": {
        title: "Why Choose Evry Health | Texas Health Insurance",
        description: "See why Texas employers choose Evry Health: no copays, no deductibles, $0 telehealth, and a personalized member care team.",
        twitterTitle: "Why Choose Evry Health",
        twitterDescription: "See why Texas employers choose Evry Health: no copays, no deductibles, $0 telehealth."
    }
};
function getPageSeo(slug) {
    var page = PAGE_SEO[slug] || {};
    var title = page.title || SITE_CONFIG.name;
    var description = page.description || "";
    var ogTitle = page.ogTitle || title;
    var ogDescription = page.ogDescription || description;
    var ogImage = page.ogImage || SITE_CONFIG.defaultOgImage;
    var twitterTitle = page.twitterTitle || ogTitle;
    var twitterDescription = page.twitterDescription || ogDescription;
    var twitterImage = page.twitterImage || ogImage;
    var noindex = page.noindex || false;
    var url = slug === "" ? "".concat(SITE_CONFIG.url, "/") : "".concat(SITE_CONFIG.url, "/").concat(slug);
    return {
        title: title,
        description: description,
        url: url,
        ogTitle: ogTitle,
        ogDescription: ogDescription,
        ogImage: ogImage,
        twitterTitle: twitterTitle,
        twitterDescription: twitterDescription,
        twitterImage: twitterImage,
        noindex: noindex
    };
}

;// CONCATENATED MODULE: ./components/SEO/SEO.js





var SEO = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, slug = ref.slug, overrides = ref.overrides;
    var router = (0,next_router.useRouter)();
    var resolvedSlug = slug !== undefined ? slug : router.pathname.replace(/^\//, "");
    var resolved = getPageSeo(resolvedSlug);
    var seo = overrides ? (0,_object_spread/* default */.Z)({}, resolved, overrides) : resolved;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: seo.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: seo.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: seo.ogTitle
            }, "title"),
            seo.noindex && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "robots",
                content: "noindex,follow"
            }),
            !seo.noindex && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: seo.url
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:site_name",
                        content: SITE_CONFIG.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: seo.url
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: seo.ogDescription
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: seo.ogImage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: SITE_CONFIG.twitterCard
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: seo.twitterTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: seo.twitterDescription
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: seo.twitterImage
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var SEO_SEO = (SEO);


/***/ }),

/***/ 8369:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react_dropzone__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8074);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7066);
/* harmony import */ var _mui_material_LinearProgress__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(1458);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(5616);
/* harmony import */ var _hooks_useReportError__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9653);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8148);
/* harmony import */ var _utils_recaptcha__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3575);
/* harmony import */ var _Recaptcha_RecaptchaModal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4559);














var getColor = function(props) {
    if (props.isDragAccept) {
        return "#00e676";
    }
    if (props.isDragReject) {
        return "#ff1744";
    }
    if (props.isFocused) {
        return "#2196f3";
    }
    return "#dbd9d9";
};
function Dropbox(param) {
    var onDrop = param.onDrop, setUploadStatus = param.setUploadStatus, uploadStatus = param.uploadStatus, setFileList = param.setFileList;
    var ref = (0,react_dropzone__WEBPACK_IMPORTED_MODULE_1__/* .useDropzone */ .uI)({
        accept: "image/*,application/pdf,.doc,.docx",
        onDrop: onDrop,
        noClick: true,
        noKeyboard: true
    }), getRootProps = ref.getRootProps, getInputProps = ref.getInputProps, acceptedFiles = ref.acceptedFiles, open = ref.open, isDragAccept = ref.isDragAccept, isFocused = ref.isFocused, isDragReject = ref.isDragReject;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0), fileProgress = ref1[0], setFileProgress = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0), _ = ref2[0], triggerRerender = ref2[1];
    var reportError = (0,_hooks_useReportError__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().reportError;
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), pendingFiles = ref3[0], setPendingFiles = ref3[1];
    var dragState = {
        isDragAccept: isDragAccept,
        isFocused: isFocused,
        isDragReject: isDragReject
    };
    var controller = new AbortController();
    var listWithRemove = acceptedFiles.map(function(file, index) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
            className: "p-2 mb-2 rounded-md bg-[#f9f9f9] drop-shadow-sm",
            children: [
                file.path,
                " - ",
                (file.size / 1000000).toFixed(2),
                " mb",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    type: "button",
                    className: "ml-2 cursor-pointer text-red",
                    onClick: function() {
                        acceptedFiles.splice(index, 1);
                        triggerRerender(_ + 1);
                    },
                    children: "x"
                })
            ]
        }, index);
    });
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (acceptedFiles.length === 0) {
            setUploadStatus("selectFiles");
        }
        if (acceptedFiles.length > 0) {
            setUploadStatus("startUpload");
        }
    }, [
        acceptedFiles,
        _
    ]);
    var submitFile = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(e) {
            var token, err, formData, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, file, response, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        if (!(acceptedFiles && acceptedFiles.length > 0)) return [
                            3,
                            8
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0,_utils_recaptcha__WEBPACK_IMPORTED_MODULE_8__/* .getRecaptchaV3Token */ .o)("upload_files")
                        ];
                    case 2:
                        token = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        console.error("recaptcha error", err);
                        setUploadStatus("error");
                        return [
                            2
                        ];
                    case 4:
                        setUploadStatus("uploading");
                        formData = new FormData();
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(_iterator = acceptedFiles[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                file = _step.value;
                                formData.append("files", file, file.name);
                            }
                        } catch (err1) {
                            _didIteratorError = true;
                            _iteratorError = err1;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        // include captcha token for backend verification (structured fields expected)
                        formData.append("captcha_token.token", token);
                        formData.append("captcha_token.version", "v3");
                        formData.append("captcha_token.provider", "1");
                        _state.label = 5;
                    case 5:
                        _state.trys.push([
                            5,
                            7,
                            ,
                            8
                        ]);
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_9__/* ["default"].request */ .Z.request({
                                method: "POST",
                                url: "".concat(_constants__WEBPACK_IMPORTED_MODULE_4__/* .BASE_URL */ ._, "/Marketing/AuthorizationRequest"),
                                data: formData,
                                onUploadProgress: function(p) {
                                    setFileProgress(p.loaded / p.total);
                                },
                                signal: controller.signal
                            })
                        ];
                    case 6:
                        response = _state.sent();
                        setFileProgress(1);
                        if (response.status >= 200 && response.status <= 299) {
                            setUploadStatus("success");
                            setFileList(acceptedFiles.map(function(file) {
                                return file.path;
                            }));
                        } else if (response.status === 400) {
                            // need v2 checkbox fallback
                            setUploadStatus("selectFiles");
                            // show checkbox overlay to obtain v2 token and resubmit
                            setPendingFiles(acceptedFiles.slice());
                            setUploadStatus("awaitingVerification");
                            setShowCheckbox(true);
                        } else {
                            setUploadStatus("error");
                            reportError(response);
                        }
                        return [
                            3,
                            8
                        ];
                    case 7:
                        error = _state.sent();
                        if (axios__WEBPACK_IMPORTED_MODULE_9__/* ["default"].isCancel */ .Z.isCancel(error)) {} else {
                            reportError(error);
                        }
                        return [
                            3,
                            8
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return function submitFile(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), showCheckbox = ref4[0], setShowCheckbox = ref4[1];
    var handleCheckboxVerify = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(token) {
            var pending, formData, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, file, response, err;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setShowCheckbox(false);
                        pending = pendingFiles;
                        if (!pending || pending.length === 0) return [
                            2
                        ];
                        formData = new FormData();
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(_iterator = pending[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                file = _step.value;
                                formData.append("files", file, file.name);
                            }
                        } catch (err1) {
                            _didIteratorError = true;
                            _iteratorError = err1;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        formData.append("captcha_token.token", token);
                        formData.append("captcha_token.version", "v2");
                        formData.append("captcha_token.provider", "1");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_9__/* ["default"].request */ .Z.request({
                                method: "POST",
                                url: "".concat(_constants__WEBPACK_IMPORTED_MODULE_4__/* .BASE_URL */ ._, "/Marketing/AuthorizationRequest"),
                                data: formData,
                                onUploadProgress: function(p) {
                                    return setFileProgress(p.loaded / p.total);
                                },
                                signal: controller.signal
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        if (response.status >= 200 && response.status <= 299) {
                            setUploadStatus("success");
                            setFileList(pending.files.map(function(f) {
                                return f.path;
                            }));
                        } else {
                            setUploadStatus("error");
                            reportError(response);
                        }
                        return [
                            3,
                            5
                        ];
                    case 3:
                        err = _state.sent();
                        reportError(err);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setPendingFiles(null);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleCheckboxVerify(token) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancel = function() {
        controller.abort();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: "dropbox",
                style: {
                    alignSelf: "center",
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
                        className: "dropbox",
                        style: {
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            borderWidth: "2px",
                            borderColor: "".concat(getColor(dragState)),
                            borderStyle: "dashed",
                            marginTop: "20px",
                            color: "black",
                            outline: "none",
                            transition: "border 0.24s ease-in-out"
                        }
                    }, getRootProps({
                        isDragAccept: isDragAccept,
                        isFocused: isFocused,
                        isDragReject: isDragReject
                    })), {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    padding: "30px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, getInputProps())),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        className: "w-14 opacity-80",
                                        src: "/upload.svg"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "pb-2 text-xl text-grey",
                                        children: "Drag & drop files here"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-lg text-grey",
                                        children: "or"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        type: "button",
                                        className: "p-2 px-4 mt-2 transition-all duration-200 border shadow-sm bg-white-light border-[#009dff] hover:bg-[#e1f0fa] text-[#009dff]",
                                        onClick: open,
                                        children: "Browse Files"
                                    }),
                                    acceptedFiles.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("aside", {
                                            className: "p-2 mt-4 overflow-y-auto max-h-24",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                children: listWithRemove
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                sx: {
                                    width: "100%"
                                },
                                children: fileProgress > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_LinearProgress__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                    variant: "determinate",
                                    value: fileProgress * 100
                                })
                            })
                        ]
                    })),
                    acceptedFiles.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            disabled: uploadStatus !== "startUpload",
                            type: "button",
                            className: "w-full p-2 px-4 mt-2 transition-all duration-200 border shadow-sm bg-[#007bff] border-blue hover:bg-[#1985fa] text-white-light disabled:bg-lightGrey disabled:text-black-default disabled:cursor-not-allowed ".concat(uploadStatus === "Success!" ? "disabled:bg-green disabled:text-white" : ""),
                            onClick: submitFile,
                            children: uploadStatus === "startUpload" ? "Upload files" : uploadStatus === "uploading" ? "Uploading..." : uploadStatus === "success" ? "Done!" : "Error"
                        })
                    })
                ]
            }),
            showCheckbox && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Recaptcha_RecaptchaModal__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                message: "Please complete the verification to continue",
                onVerify: function(token) {
                    return handleCheckboxVerify(token);
                },
                onError: function() {
                    setShowCheckbox(false);
                    setUploadStatus("error");
                },
                onClose: function() {
                    return setShowCheckbox(false);
                }
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Dropbox);


/***/ }),

/***/ 8148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ BASE_URL; }
/* harmony export */ });
var BASE_URL =  true && window.location.hostname.includes("evryhealth.com") ? "https://api.evryhealth.com/api/v1" : "https://apidev.evryhealth.com/api/v1/";


/***/ }),

/***/ 2219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useRecaptchaLoader; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

function useRecaptchaLoader() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), loaded = ref[0], setLoaded = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), error = ref1[0], setError = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (false) {}
        var siteKey = "6LcH66wrAAAAAEW3rb_ohWMciDcO_dxeskFi3cj5";
        if (!siteKey) {
            return;
        }
        if (window.grecaptcha && window.grecaptcha.execute) {
            setLoaded(true);
            return;
        }
        // If a recaptcha script is already present, poll for grecaptcha to become available
        var existing = Array.from(document.getElementsByTagName("script")).find(function(s) {
            return s.src && s.src.includes("recaptcha/api.js");
        });
        if (existing) {
            var mounted = true;
            var interval = setInterval(function() {
                if (!mounted) return clearInterval(interval);
                if (window.grecaptcha && window.grecaptcha.execute) {
                    setLoaded(true);
                    clearInterval(interval);
                }
            }, 250);
            return function() {
                mounted = false;
                clearInterval(interval);
            };
        }
        var script = document.createElement("script");
        script.src = "https://www.google.com/recaptcha/api.js?render=".concat(siteKey);
        script.async = true;
        script.defer = true;
        script.onload = function() {
            try {
                if (window.grecaptcha && window.grecaptcha.execute) {
                    window.grecaptcha.ready(function() {
                        return setLoaded(true);
                    });
                } else {
                    // fallback poll
                    var count = 0;
                    var interval = setInterval(function() {
                        if (window.grecaptcha && window.grecaptcha.execute) {
                            clearInterval(interval);
                            window.grecaptcha.ready(function() {
                                return setLoaded(true);
                            });
                        }
                        count++;
                        if (count > 40) {
                            clearInterval(interval);
                            setError(new Error("grecaptcha not available after load"));
                        }
                    }, 250);
                }
            } catch (err) {
                setError(err);
            }
        };
        script.onerror = function(err) {
            return setError(err || new Error("recaptcha script failed to load"));
        };
        document.head.appendChild(script);
        return function() {};
    }, []);
    return {
        loaded: loaded,
        error: error
    };
}


/***/ }),

/***/ 9653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7582);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8148);



var useReportError = function() {
    var reportError = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(errors) {
            var response, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            fetch("".concat(_constants__WEBPACK_IMPORTED_MODULE_0__/* .BASE_URL */ ._, "/Marketing/ReportError"), {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                body: JSON.stringify({
                                    value: "Error report marketing website :: " + JSON.stringify(errors)
                                })
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        response = error;
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2,
                            response
                        ];
                }
            });
        });
        return function reportError(errors) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        reportError: reportError
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useReportError);


/***/ }),

/***/ 3575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ getRecaptchaV3Token; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7582);


var recaptchaReady = false;
function waitForGrecaptchaReady() {
    return _waitForGrecaptchaReady.apply(this, arguments);
}
function _waitForGrecaptchaReady() {
    _waitForGrecaptchaReady = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function() {
        var timeoutMs, siteKey;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            timeoutMs = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : 30000;
            if (false) {}
            siteKey = "6LcH66wrAAAAAEW3rb_ohWMciDcO_dxeskFi3cj5";
            if (!siteKey) throw new Error("recaptcha: NEXT_PUBLIC_RECAPTCHA_SITE_KEY_V3 is not set");
            if (recaptchaReady) return [
                2
            ];
            return [
                2,
                new Promise(function(resolve, reject) {
                    // wait for grecaptcha.ready to become available
                    var overall = setTimeout(function() {
                        var msg = "reCAPTCHA not available; ensure the script is included: https://www.google.com/recaptcha/api.js?render=SITE_KEY";
                        console.error("recaptcha:", msg);
                        reject(new Error(msg));
                    }, timeoutMs);
                    var check = function() {
                        if (window.grecaptcha && typeof window.grecaptcha.ready === "function") {
                            try {
                                window.grecaptcha.ready(function() {
                                    clearTimeout(overall);
                                    recaptchaReady = true;
                                    resolve();
                                });
                            } catch (e) {
                                clearTimeout(overall);
                                console.error("recaptcha: error during grecaptcha.ready", e);
                                reject(e);
                            }
                        } else {
                            setTimeout(check, 100);
                        }
                    };
                    check();
                })
            ];
        });
    });
    return _waitForGrecaptchaReady.apply(this, arguments);
}
function withTimeout(promise) {
    var timeoutMs = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 30000;
    return new Promise(function(resolve, reject) {
        var t = setTimeout(function() {
            return reject(new Error("reCAPTCHA process timeout"));
        }, timeoutMs);
        promise.then(function(r) {
            clearTimeout(t);
            resolve(r);
        }).catch(function(err) {
            clearTimeout(t);
            reject(err);
        });
    });
}
function getRecaptchaV3Token() {
    return _getRecaptchaV3Token.apply(this, arguments);
}
function _getRecaptchaV3Token() {
    _getRecaptchaV3Token = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function() {
        var action, siteKey;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    action = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "submit";
                    return [
                        4,
                        waitForGrecaptchaReady()
                    ];
                case 1:
                    _state.sent();
                    siteKey = "6LcH66wrAAAAAEW3rb_ohWMciDcO_dxeskFi3cj5";
                    return [
                        2,
                        withTimeout(new Promise(function(resolve, reject) {
                            try {
                                var exec = window.grecaptcha.execute(siteKey, {
                                    action: action
                                });
                                if (exec && typeof exec.then === "function") {
                                    exec.then(function(token) {
                                        return resolve(token);
                                    }).catch(function(err) {
                                        console.error("recaptcha: grecaptcha.execute promise rejected", err);
                                        reject(err);
                                    });
                                } else {
                                    var _$err = new Error("reCAPTCHA v3 execute is not returning a promise");
                                    console.error("recaptcha:", _$err);
                                    reject(_$err);
                                }
                            } catch (err) {
                                console.error("recaptcha: exception while calling grecaptcha.execute", err);
                                reject(err);
                            }
                        }))
                    ];
            }
        });
    });
    return _getRecaptchaV3Token.apply(this, arguments);
}


/***/ })

}]);